// File: sliders/ArticleSimpleSlider.jsx
import { Link } from 'react-router-dom';

import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import { NextButton, PrevButton } from '@/shared-components/buttons/components/SliderControls';
import BoardCard from '@/shared-components/forms/add-board-content/shared-components/BoardCard';
import FHSlider from '@/shared-components/sliders/components/FHSlider';
import Heading from '@/shared-components/text/components/Heading';

import './styles/ArticleSimpleSlider.css';

// same normalizer as everywhere else
function adaptArticle(item) {
  const sevenDaysMs = 7 * 24 * 60 * 60 * 1000;
  const created = item.createdAt ? new Date(item.createdAt) : null;
  const recentlyPublished = created
    ? Date.now() - created.getTime() <= sevenDaysMs
    : false;

  return {
    ...item,
    recentlyPublished,
    post_container: {
      post_title: item.title,
      post_description: item.description,
      post_cover: { image_id: item.coverImageId },
    },
    post_status: item.status,
    post_visits: item.visits,
    comment_count: item.comment_count ?? 0,
    post_like_count: item.post_like_count ?? 0,
    is_liked: item.is_liked,
  };
}

export default function ArticleSimpleSlider({
  articles = [],
  category = '',
  link = '',
}) {
  return (
    <div className="article-simple-slider__container element-non-selectable">
      {/* header with title + see-all */}
      <div className="article-simple-slider__header">
        <Heading className="article-simple-slider__category">
          {category}
        </Heading>
        {link && (
          <Link to={link} className="no-underline">
            <ContinueButton className="article-simple-slider__see-all">
              See all
            </ContinueButton>
          </Link>
        )}
      </div>
      <FHSlider
        speed={1.4}
        className="article-simple-slider__slider"
        customPrevButton={<PrevButton />}
        customNextButton={<NextButton />}
      >
        {articles.map(article => {
          const adapted = adaptArticle(article);
          return (
            <div
              key={article._id}
              className="article-simple-slider__slider-item"
            >
              <div className="article-simple-slider__card">
                <BoardCard data={adapted} variant="editorial" />
              </div>
            </div>
          );
        })}
      </FHSlider>
    </div>
  );
}
